module.exports = __webpack_public_path__ + "img/useFlow-big-start.df4dfc5.png";